import { userConstants } from '../constant/user'


export default function user(state = {}, action) {
  switch (action.type) {

    case userConstants.READ_USERS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case userConstants.READ_USERS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case userConstants.READ_USERS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}